export default __webpack_public_path__ + "static/media/SILA.249b1c3d.png";